import React from 'react'
import { FormattedMessage } from 'react-intl';
import logo from '../../assets/images/logo.svg'

const Logo = () => {
    return (
        <FormattedMessage id="app.website">
            {
                url => 
                <a href={url} className="app__logo"><img src={logo} alt="Smart-ID" /></a>
            }
        </FormattedMessage>
    )
}

Logo.propTypes = {

}

export default Logo
